module.exports = __webpack_public_path__ + "static/media/phone.d5192b1c.png";